import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

import { DashboardCard } from './total-calls';

import type { CardProps } from '@/types/dashboard.type';

type Props = {
  cards: CardProps[];
  loading: boolean;
};

const SKELETON_KEYS = ['total-calls', 'answered-rate', 'error-rate'] as const;

const KpiSkeleton = () => (
  <Card className="@container/card">
    <CardContent className="p-4">
      <div className="space-y-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-8 w-16" />
        <Skeleton className="h-3 w-32" />
      </div>
    </CardContent>
  </Card>
);

export const KpiGrid = ({ cards, loading }: Props) => {
  return (
    <div className="*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-1 gap-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs sm:grid-cols-2 lg:grid-cols-3 @xl/main:grid-cols-2 @5xl/main:grid-cols-4">
      {loading
        ? SKELETON_KEYS.map(key => <KpiSkeleton key={key} />)
        : cards.map(data => <DashboardCard key={data.title} info={data} />)}
    </div>
  );
};
